// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> river-s-cove
// Generated: 2026-11-02T18:10:19.378Z
// Counts: 0 design, 39 content, 20 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Two and Three Bedroom Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Germantown Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to River's Cove</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At River's Cove, your apartment in Germantown, WI features in-home comforts and inviting community perks. Curl up by your wood-burning fireplace or enjoy serene pond views. Wash day is simple with an in-unit washer/dryer. Step outside to the dog park or stroll by the water - enjoy every convenience designed for your comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Connect with our professional leasing team at River's Cove in Germantown, WI. Whether you want details, a guided tour, or to ask about availability, we're ready to help you learn more about our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our apartments for rent in Germantown, WI offer spacious two- and three-bedroom layouts. Each home features a cozy fireplace, energy-efficient appliances, and space for work or hobbies. Plenty of storage and walk-in closets help keep you organized. Imagine unwinding at home or catching up on work in your bright, inviting space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from stunning two- and three-bedroom layouts.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at River's Cove through our photo gallery. Picture yourself relaxing in your cozy living room, gathering with friends in spacious kitchens, or exploring bright bedrooms and walk-in closets. Peek at river views, serene pond scenes, and inviting community spaces captured for you.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Comfy apartments near Mequon Road - pet-friendly and welcoming.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience vibrant living in downtown Germantown, WI at River's Cove. Mequon Road brings local shopping, dining, and the Blackstone Creek Golf Club within minutes of your front door. Enjoy a short stroll to river paths or pop over to nearby green spaces. With community events and easy access to everything Germantown offers, your days will be filled with energy and comfort.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the heart of Germantown, River's Cove offers spacious two and three-bedroom apartments surrounded by vibrant local attractions. Enjoy leisurely afternoons at nearby Kettle Hills Golf Course, explore the Mequon Nature Preserve, or unwind at Dretzka Park. Embrace a lifestyle rich in convenience and community at River's Cove.Out your door, Mequon Road winds past favorite local stops. The Blackstone Creek Golf Club sits nearby, perfect for an afternoon round or scenic walks. Community events keep things lively, while nearby outdoor spaces and the river brighten every day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Germantown, WI? River's Cove blends relaxed living with modern touches in a warm, pet-friendly community. Our furnished units and river kayak drop-off suit both everyday routines and weekend adventures. Cozy up by your wood-burning fireplace or enjoy river views from your home. Here, living feels easy, and neighbors feel like friends.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to see your new space? Tour River's Cove apartments in Germantown, WI. Choose from live virtual, in-person, or appointment-based guided tours to get an up-close feel for our two- and three-bedroom floor plans and peaceful community. Your next step is simple and flexible; let us help you find your new home your way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our virtual tour lets you experience River's Cove Apartments from anywhere. Imagine moving through bright living spaces, viewing modern floor plans, and getting a glimpse of welcoming common areas, all from your laptop or phone. It's a simple way to picture your everyday life at River's Cove in Germantown, WI - find your fit, your pace, your comfort, all online.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-90e0-72de-9964-80a49bf1218c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with sofa, armchair, fireplace, and lake view."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-90e7-7637-af8e-fb235d3e301e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cozy living room with a fireplace, sofa, coffee table, and large mirror."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-90e1-71ea-9d78-e9cb2ec34b72.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Dining area with round table and chairs, and kitchen counter with stools."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-9a79-729c-95f5-3396d69c0db0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen breakfast bar set with wine and decorative plates at River's Cove"
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-9c95-73db-bd5c-76b3f01f34e1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A beautifully decorated bedroom with a large bed, nightstands, and wall decor."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-90e7-7637-af8e-f42f7cd4a14a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a blue sofa, white accent chairs, and a coffee table."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-b4c7-71d4-ac1e-37416487a9b0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Sunny exterior view of River's Cove apartment buildings in Germantown, WI"
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-9c95-73db-bd5c-7e8cdca881a7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with black refrigerator, white cabinets, and dishwasher."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-9c95-73db-bd5c-76b3f01f34e1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A beautifully decorated bedroom with a large bed, nightstands, and wall decor."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167252/019d022a-90e0-72de-9964-80a49bf1218c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with sofa, armchair, fireplace, and lake view."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
